import { CircularProgress, Grid } from '@mui/material';

const LoadingIndicator = () => (
  <Grid
    container
    alignItems="center"
    justifyContent="center"
    sx={{
      minHeight: '100vh'
    }}
  >
    <Grid
      item
      xs="auto"
    >
      <CircularProgress />
    </Grid>
  </Grid>
);

export default LoadingIndicator;
